<template>
  <div class="tabBox">
    <el-table :data="arrList" style="width: 100%;text-align: center;" highlight-current-row  @row-click="check_risk">
      <el-table-column prop="name" align="center" label="名称">
      </el-table-column>
      <el-table-column prop="gender" align="center" label="性别">
      </el-table-column>
      <el-table-column align="center" label="出生年月">
        <template slot-scope="scope">
          <span>{{timeFormat(scope.row.birthday)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="professionDuty" align="center" label="职称">
      </el-table-column>
      <el-table-column prop="unitName" align="center" label="工作单位">
      </el-table-column>
      <el-table-column prop="provinceName" align="center" label="所属省">
      </el-table-column>
      <el-table-column prop="cityName" align="center" label="所属市">
      </el-table-column>
      <el-table-column prop="countyName" align="center" label="所属县">
      </el-table-column>
      <el-table-column prop="professionalField" align="center" label="技术领域特长">
      </el-table-column>
      <el-table-column prop="mobilePhone" align="center" label="手机号码">
      </el-table-column>
      <el-table-column prop="expertType" align="center" label="备注">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: ['arrList'],
  data() {
    return {
      tableData: []
    }
  },
  methods: {
    // 时间格式化
    timeFormat(val) {
      if (val) {
        return moment(val).format('YYYY-MM')
      }
    },
    // 点击行
    check_risk(row) {
    },
  }
}

</script>
<style>


</style>



// WEBPACK FOOTER //
// experList.vue?2ba3baba